import { GraphQLError } from "./GraphQLError.mjs";
/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

export function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}



//////////////////
// WEBPACK FOOTER
// ./~/graphql/error/syntaxError.mjs
// module id = qrnq
// module chunks = 9